<template>
  <div>
    <div class="d-flex align-items-center">
      <h1>Listado de tarifas </h1>
      <b-button
        v-b-tooltip.hover
        size="sm"
        :href="urlAdd()"
        variant="primary"
        title="Agregar"
        class="ml-auto"
      >
        <font-awesome-icon :icon="['fas', 'plus']"/> Tarifa
      </b-button>
    </div>
    <b-card>
      <Loading :active="loading2" :is-full-page="true"></Loading>
      <b-table
        :items="items"
        :fields="fields"
        stacked="md"
        show-empty
        small
      >
        <template #cell(actions)="row">
          <b-button v-b-tooltip.hover size="sm" @click="info(row, $event.target)" class="mr-1" variant="outline-primary" title="Editar">
            <font-awesome-icon :icon="['fas', 'edit']"/>
          </b-button>
          <b-button v-b-tooltip.hover size="sm" @click="deleteRate(row, $event.target)" class="mr-1" variant="danger" title="Eliminar">
            <font-awesome-icon :icon="['fas', 'trash-alt']"/>
          </b-button>
        </template>
      </b-table>
    </b-card>
    <b-modal v-if="selectedItem" :id="infoModal.id" ref="modal111" :title="infoModal.title" ok-only @hide="resetInfoModal" @shown="changeZIndex">
      <ValidationObserver ref="form" >
        <b-form @submit.prevent="onSubmit">
          <p class="text-danger">Poner 0 en max cuando la tarifa va a ser la mas alta</p>
          <Loading :active="loading" :is-full-page="true"></Loading>
          <div class="row">
            <div class="col-sm-6">
              <ValidationProvider name="Min" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-min"
                  label-for="min"
                  label="Min"
                  class="mb-0"
                >
                  <b-form-input v-model="selectedItem.sale" id="min" placeholder="Cantidad minima" :state="getState(validated, valid)"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-sm-6">
              <ValidationProvider name="Max" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-max"
                  label-for="max"
                  label="Max"
                  class="mb-0"
                >
                  <b-form-input v-model="selectedItem.sale_max" id="max" placeholder="Cantidad maxima" :state="getState(validated, valid)"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-sm-6">
              <ValidationProvider name="Porcentaje" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-percentage"
                  label-for="percentage"
                  label="Porcentaje"
                  class="mb-0"
                >
                  <b-form-input v-model="selectedItem.percentage" id="percentage" placeholder="Porcentaje" :state="getState(validated, valid)"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="col-sm-6">
              <ValidationProvider name="Terminal" rules="required" v-slot="{ validated, valid }">
                <b-form-group
                  id="input-group-terminal"
                  label-for="terminal"
                  label="terminal"
                  class="mb-0"
                >
                  <b-form-select
                    id="select-terminal"
                    class="form-control"
                    v-model="selectedItem.terminal"
                    :state="getState(validated, valid)"
                  >
                    <b-select-option v-for="p in terminals" :key="p" :value="p">{{p}}</b-select-option>
                  </b-form-select>
                </b-form-group>
              </ValidationProvider>
            </div>
          </div>
          <b-alert v-model="showDismissibleAlert" variant="danger" class="mt-4">
            <div v-if="errors" class="d-flex">
              <ul style="list-style-type:none;" class="p-0 m-0">
                <template v-for="(field, i) in errors">
                  <li v-for="(m, index) in field" :key="i+index" class="text-danger">{{ m }}</li>
                </template>
              </ul>
            </div>
          </b-alert>
          <b-alert v-model="showAlertOk" variant="success" class="mt-4">
            <p>{{messageOk}}</p>
          </b-alert>
        </b-form>
      </ValidationObserver>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            size="sm"
            class="float-left"
            @click="$root.$emit('bv::hide::modal', infoModal.id)"
          >
            Cancelar
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="onSubmit"
          >
            Guardar
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
  import { required, email } from 'vee-validate/dist/rules'
  extend('email', email)
  extend('required', required)
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  export default {
    name: 'ReservationsAdmin',
    props:['items'],
    components: {FontAwesomeIcon, ValidationObserver, ValidationProvider},
    data() {
      return {
        messageOk:null,
        errors:null,
        showAlertOk:false,
        loading:false,
        loading2:false,
        fields:[
          { key: 'id', label: 'ID' },
          { key: 'sale', label: 'Min' },
          { key: 'sale_max', label: 'Max' },
          { key: 'percentage', label: 'Porcentage' },
          { key: 'terminal', label: 'Terminal' },
          { key: 'actions', label: 'Actions' },
        ],
        terminals:['T2','T3-T4',],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
        selectedItem : null,
      }
    },
    
    mounted() {
      // Set the initial number of items
      this.totalRows = this.items.length
    },
    methods: {
      deleteRate(row, button) {
        let item = row.item
        this.$bvModal.msgBoxConfirm(`Esta seguro que desea eliminar la tarifa ID ${item.id}`, {
          title: 'Confirmacion',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            if (value) {
              this.loading2 = true
              const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/commission-rates/${row.item.id}/delete`
              this.$axios.post(url, item).then(rs => {
                this.$bvToast.toast(rs.data.message, {
                  title: `Tarifa eliminada`,
                  variant: 'success',
                  solid: true,
                  toaster: 'b-toaster-top-center',
                })
                this.loading2 = false
                location.reload();
              })
              .catch(error=> {
                if (error.response) {
                  this.errors = error.response.data.errors
                }  else {
                  this.errors = {
                    unexpected: ['Hubo un error por favor contacte al administrador']
                  }
                }
                console.log('error quote', error);
                this.loading2 = false
              })
            }
          })
          .catch(err => {
            // An error occurred
          })
      },
      getState(validated, valid) {
        if (!validated) {
          return null;
        }
        return valid
      },
      onSubmit(e) {
        e.preventDefault()
        this.errors = null
        this.updateSuccess = false
        this.showAlertOk = false
        this.$refs.form.validate().then((success) => {
          if (success) {
            this.loading = true
            const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/commission-rates/${this.selectedItem.id}/update`
            //this.$store.dispatch('quote/setRequest', this.rq)
            delete this.selectedItem.created_ad
            delete this.selectedItem.updated_at
            this.$axios.post(url, this.selectedItem).then(rs => {
              this.updateSuccess = true
              this.showAlertOk = true
              this.messageOk = rs.data.message
              this.loading = false
              location.reload();
            })
            .catch(error=> {
              if (error.response) {
                this.errors = error.response.data.errors
              }  else {
                this.errors = {
                  unexpected: ['Hubo un error por favor contacte al administrador']
                }
              }
              console.log('error quote', error);
              this.loading = false
            })
          }
        })
      },
      changeZIndex() {
        this.$refs.modal111.zIndex = 3000
      },
      info(row, button) {
        this.selectedItem = {...row.item}
        this.$nextTick(() => {
          this.infoModal.title = `Editar tarifa: ${row.item.id}`
          this.infoModal.content = JSON.stringify(row.item, null, 2)
          this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        });
        
      },
      urlEdit(i) {
        return `${process.env.MIX_APP_URL}${this.$prefixPanel}/commission-rates/${i.id}/edit`
      },
      urlAdd() {
        return `${process.env.MIX_APP_URL}${this.$prefixPanel}/commission-rates/add`
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
        this.selectedItem = null
        
      },
    },
    computed:{
      showDismissibleAlert() {
        return !(this.errors === null)
      }
    }
  }
</script>
